import React from "react";

export default function CustomLabel({ label }) {
  return (
    <span className="text-xs font-normal text-[#797979] m-1 md:hidden">
      {label}
    </span>
  );
}
